/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class ReportService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param studyId
     * @returns binary
     * @throws ApiError
     */
    public reportGet(
        studyId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/expenses',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns binary
     * @throws ApiError
     */
    public reportGetSiteRequestCountReportData(
        studyId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/siteRequestCountReportData',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns binary
     * @throws ApiError
     */
    public reportGetStudyUtilizationReportData(
        studyId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/utilizationReportData',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns binary
     * @throws ApiError
     */
    public reportGetCrcLastLoginReportData(
        studyId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/crcLastLoginReportData',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns binary
     * @throws ApiError
     */
    public reportGetPatientLastRequestSubmittedAtReportData(
        studyId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/patientLastRequestSubmittedAtReportData',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @returns binary
     * @throws ApiError
     */
    public reportGetPatientProfileCreationReportData(
        studyId: number,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/patientProfileCreationReportData',
            path: {
                'studyId': studyId,
            },
        });
    }
    /**
     * @param studyId
     * @param siteId
     * @param patientId
     * @returns binary
     * @throws ApiError
     */
    public reportGetStipendReport(
        studyId: number,
        siteId?: number | null,
        patientId?: number | null,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/stipendReport',
            path: {
                'studyId': studyId,
            },
            query: {
                'siteId': siteId,
                'patientId': patientId,
            },
        });
    }
    /**
     * @param studyId
     * @param siteId
     * @param patientId
     * @returns binary
     * @throws ApiError
     */
    public reportGetPendingPaymentStipendReport(
        studyId: number,
        siteId?: number | null,
        patientId?: number | null,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/reports/study/{studyId}/pendingPaymentStipendReport',
            path: {
                'studyId': studyId,
            },
            query: {
                'siteId': siteId,
                'patientId': patientId,
            },
        });
    }
}
